<template>
    <v-container fluid>
        <PopupForm
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.edit')"
            v-if="model"
        />
    </v-container>
</template>

<script>
import Popup from '@/models/settings/Popup'
import PopupForm from './Form'

export default {
    components: {
        PopupForm,
    },

    props: ['id'],

    data: () => {
        return {
            model: null,
        }
    },

    methods: {
        async find() {
            this.model = await new Popup().find(this.id)
        },

        saved() {
            this.$router.go(-1)
        },
    },

    created() {
        this.find()
    },
}
</script>

<style></style>
